import { Pagination } from "react-admin";
import styled from "styled-components";

const CustomPagination = (props) => (
  <StyledPagination>
    <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
  </StyledPagination>
);

export default CustomPagination;

const StyledPagination = styled.div`
  width: 95vw;
`;
